import { Globals } from "../CoreApp/Globals";

export function XML_ConvertDPI(x) {
  x = x * Globals._scaleFactor;
  return x;
}
